import React from 'react';
import { Check } from 'lucide-react';

/**
 * Stepper horizontal pro avec labels visibles, étapes complétées avec ✓,
 * étape active en surbrillance.
 *
 * Maquette : ronds verts/blancs reliés par lignes vertes (complété) ou grises (à faire).
 * Étape active : rond plein vert avec numéro blanc + label vert gras.
 * Étape complétée : rond blanc à bordure verte avec ✓ vert + label vert.
 * Étape future : rond blanc à bordure grise avec numéro gris + label gris.
 */
const WizardStepperHorizontal = ({ steps, currentIndex, completedIndexes = [], onStepClick }) => {
  return (
    <div className="w-full px-1 py-3" data-testid="wizard-stepper-horizontal">
      <div className="flex items-center justify-between gap-1">
        {steps.map((step, i) => {
          const completed = completedIndexes.includes(i) && i !== currentIndex;
          const active = i === currentIndex;
          const clickable = onStepClick && (completed || (i < currentIndex));

          // Style du rond
          const circleClass = active
            ? 'bg-emerald-600 text-white border-emerald-600 shadow-sm'
            : completed
            ? 'bg-white text-emerald-600 border-emerald-500'
            : 'bg-white text-slate-400 border-slate-300';

          // Style du label
          const labelClass = active
            ? 'text-emerald-700 font-semibold'
            : completed
            ? 'text-emerald-600 font-medium'
            : 'text-slate-400';

          return (
            <React.Fragment key={i}>
              <button
                type="button"
                disabled={!clickable}
                onClick={() => clickable && onStepClick(i)}
                className={`flex items-center gap-2 ${clickable ? 'cursor-pointer hover:opacity-80' : 'cursor-default'} transition-opacity`}
                data-testid={`stepper-step-${i + 1}`}
              >
                <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center text-xs sm:text-sm font-semibold border-2 transition-all ${circleClass}`}>
                  {completed ? <Check className="w-4 h-4" /> : (i + 1)}
                </div>
                <span className={`hidden md:inline text-xs sm:text-sm whitespace-nowrap ${labelClass}`}>
                  {step}
                </span>
              </button>
              {i < steps.length - 1 && (
                <div className={`flex-1 h-0.5 mx-1 transition-colors min-w-[12px] ${
                  i < currentIndex || completed ? 'bg-emerald-500' : 'bg-slate-200'
                }`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {/* Mobile : label étape courante visible */}
      <div className="md:hidden mt-3 text-center text-xs font-semibold text-emerald-700">
        Étape {currentIndex + 1}/{steps.length} — {steps[currentIndex]}
      </div>
    </div>
  );
};

export default WizardStepperHorizontal;
